import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
//const url = 'http://nunziabastian.loc/api/insert.php';
const url = 'https://bastianandnunzia.com/form/api/insert.php';
const url2 = 'https://bastianandnunzia.com/form/api/emails.php';
@Injectable({
  providedIn: 'root'
})
export class InvitationService {

  private option: HttpHeaders = new HttpHeaders().set('Content-type', 'x-www-form-urlencoded');
  
  constructor(private http: HttpClient) { }

  getAllEmails() {
     return this.http.get(url2);
   }

  postInvitation(form: any) {
   let param = new HttpParams()
    .set('value', JSON.stringify(form));
    return this.http.post(url, param, {headers: this.option })
  }

}
